export default __webpack_public_path__ + "static/media/DSAR_LOA_OVERDRAFT.0edb3763.pdf";